import { hot } from "react-hot-loader/root";
import React from "react";

function Lobby(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}

export default hot(Lobby);
